export class ComponentPainByFleetAtaChapter {
  id: number;
  pain_index_month: Date;
  rank: number;
  fleet_rank: number;
  cpn: string;
  noun: string;
  description: string;
  fleet_cd: string;
  rmvl_ata_chapter: string;
  pain_sum: number;
  pain_tos_delay_cost: number;
  tos_delay_cost_rank: number;
  pain_delay_cost: number;
  delay_cost_rank: number;
  fleetata_delay_rank: number;
  pain_div_cost: number;
  div_cost_rank: number;
  fleetata_div_rank: number;
  pain_rto_cost: number;
  rto_cost_rank: number;
  fleetata_rto_rank: number;
  pain_atb_cost: number;
  atb_cost_rank: number;
  fleetata_atb_rank: number;
  pain_ifsd_cost: number;
  ifsd_cost_rank: number;
  fleetata_ifsd_rank: number;
  pain_emer_cost: number;
  emer_cost_rank: number;
  fleetata_emer_rank: number;
  pain_oos_event_cost: number;
  oos_cost_rank: number;
  fleetata_oos_rank: number;
  pain_pdis_cost: number;
  pdis_cost_rank: number;
  fleetata_pdis_rank: number;
  pain_wdl_cost: number;
  wdl_cost_rank: number;
  fleetata_wdl_rank: number;
  pain_rdl_cost: number;
  rdl_cost_rank: number;
  fleetata_rdl_rank: number;
  pain_unsched_cost: number;
  unsched_cost_rank: number;
  fleetata_unsched_rank: number;
  pain_bfs_cost: number;
  bfs_cost_rank: number;
  fleetata_bfs_rank: number;
  pain_other_rmvl_cost: number;
  other_rmvl_cost_rank: number;
  fleetata_other_rmvl_rank: number;
  pain_low_tsi_cost: number;
  low_tsi_cost_rank: number;
  fleetata_low_tsi_rank: number;
  pain_nff_cost: number;
  nff_cost_rank: number;
  fleetata_nff_rank: number;
  pain_repair_cost: number;
  repair_cost_rank: number;
  fleetata_repair_rank: number;
  m2_count: number;
  m2_count_rank: number;
  fleetata_m2_count_rank: number;
  div_count: number;
  div_count_rank: number;
  fleetata_div_count_rank: number;
  rto_count: number;
  rto_count_rank: number;
  fleetata_rto_count_rank: number;
  atb_count: number;
  atb_count_rank: number;
  fleetata_atb_count_rank: number;
  ifsd_count: number;
  ifsd_count_rank: number;
  fleetata_ifsd_count_rank: number;
  emer_count: number;
  emer_count_rank: number;
  fleetata_emer_count_rank: number;
  oos_event_count: number;
  oos_event_count_rank: number;
  fleetata_oos_event_count_rank: number;
  wdl_count: number;
  wdl_count_rank: number;
  fleetata_wdl_count_rank: number;
  rdl_count: number;
  rdl_count_rank: number;
  fleetata_rdl_count_rank: number;
  total_m2_dly_minutes: number;
  total_m2_dly_minutes_rank: number;
  fleetata_total_m2_dly_minutes_rank: number;
  avg_m2_dly_minutes: number;
  avg_m2_dly_minutes_rank: number;
  fleetata_avg_m2_dly_minutes_rank: number;
  total_removals: number;
  total_removals_rank: number;
  fleetata_total_removals_rank: number;
  unscheduled_rmvls: number;
  unscheduled_rmvls_rank: number;
  fleetata_unscheduled_rmvls_rank: number;
  bfs_rmvls: number;
  bfs_rmvls_rank: number;
  fleetata_bfs_rmvls_rank: number;
  unsched_or_bfs_rmvls: number;
  unsched_or_bfs_rmvls_rank: number;
  fleetata_unsched_or_bfs_rmvls_rank: number;
  bfs_rate: number;
  bfs_rate_rank: number;
  fleetata_bfs_rate_rank: number;
  nff_rate: number;
  nff_rate_rank: number;
  fleetata_nff_rate_rank: number;
  pain_fuel_penalty_cost: number;
  fuel_penalty_cost_rank: number;
  mech_flag: number;
  excluded: number;
  MATERIEL_ATA: string;
  MATERIEL_ATA_CHAPTER: string;
  ATA_DESCRIPTION: string;
  ATA_GROUP: string;
  fleets: string;
  pain_oos_direct_cost: number;
  oos_direct_cost_rank: number;
  fleetata_oos_direct_cost_rank: number;
  pain_oos_indirect_cost: number;
  oos_indirect_cost_rank: number;
  fleetata_oos_indirect_cost_rank: number;
  oos_event_min: number;
  oos_event_min_rank: number;
  fleetata_oos_event_min_rank: number;
  oos_event_hrs: number;
  oos_event_hrs_rank: number;
  fleetata_oos_event_hrs_rank: number;
  rank_prev1mo: number;
  rank_change_prev1mo: number;
  rank_prev3mo: number;
  rank_change_prev3mo: number;
  rank_prev6mo: number;
  rank_change_prev6mo: number;
  rank_prev12mo: number;
  rank_change_prev12mo: number;
  rank_prev36mo: number;
  rank_change_prev36mo: number;
}
